import { render, staticRenderFns } from "./engineering-income-list.vue?vue&type=template&id=2b892a34&scoped=true&"
import script from "./engineering-income-list.vue?vue&type=script&lang=js&"
export * from "./engineering-income-list.vue?vue&type=script&lang=js&"
import style0 from "./engineering-income-list.vue?vue&type=style&index=0&id=2b892a34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b892a34",
  null
  
)

export default component.exports